module.exports = __webpack_public_path__ + "@/assets/img/07.06f5093c.svg";